export default __webpack_public_path__ + "static/media/paralax.845f2bea.png";